import aqilaApi from './aqila-api';

export type Historico = {
  naoLidas: number;
  propriedade: number;
  atualizado: string;
  atualizadoDataHora: string;
};

class Historicos {
  async all(): Promise<Historico[]> {
    const { data } = await aqilaApi.get<Historico[]>('v1/historicos');
    return data;
  }

  async markAsRead(propriedadeId: number): Promise<void> {
    await aqilaApi.delete(`v1/historicos/${propriedadeId}/propriedade`);
  }
}

export default new Historicos();
